module.exports = __webpack_public_path__ + "static/media/008-folder-1.ec7f9300.svg";